import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// element plus 中文包
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'dayjs/locale/zh-cn'
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
dayjs.extend(weekday);
dayjs.locale('zh-cn')

// 引入公共样式
import './style/common.css'

// 引入element plus的css
import 'element-plus/theme-chalk/el-loading.css'
import 'element-plus/theme-chalk/el-message.css'

// 引入svg
import '@/assets/icon/svg'

//引入路由守卫
import './permission'

// 引入自定义指令
import btnhasPermission from './directives/btnhasPermission'

const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.directive('btnhasPermission', btnhasPermission)
app.use(store)
app.use(router)
app.use(ElementPlus, {
  locale: zhCn
})
app.mount('#app')
